import { Button } from '@mm/components';
import { MyLeadsSearchQuery } from '@mm/state/interfaces/myLeads';
import {
  FilterItem,
  FilterItemOperatorTypes,
  FILTER_TYPES,
} from '@mm/state/model/AudiencesModel';
import { getUniqId } from '@mm/utils';
import { isObject } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { AudienceFilterItemInput } from '../../../../../../../common/components/AudienceFilterItemInput/AudienceFilterItemInput';
import { useFilterParams } from '../use-filter-params';
import styles from './OtherAttributesFilter.module.css';

type Props = {
  filterParams: MyLeadsSearchQuery;
  setFilterParams: (params: MyLeadsSearchQuery) => void;
  disabled?: boolean;
};

export const OtherAttributesFilter = ({
  filterParams,
  setFilterParams,
  disabled,
}: Props) => {
  const blankFilterItem: FilterItem = {
    filterType: '',
    operator: undefined,
    value: '',
    variableId: 0,
    variableType: 'SystemVariable',
    variable: '',
  };
  const [filter, setFilter] = useState<FilterItem>(blankFilterItem);
  const { getUpdatedVariablesFilterParams, getUpdatedFilterParams } =
    useFilterParams({ filterParams });

  const hasFiltersByAttributes: FilterItem[] = useMemo(
    () => filterParams.filterParams?.length,
    [filterParams?.filterParams],
  );

  const onUpdateOtherFilters = (filter: FilterItem) => {
    const uniqId = getUniqId('filter');
    const updatedFilter = {
      ...filter,
      filterType: FILTER_TYPES.variableValues,
      uniqId,
    };
    setFilter(updatedFilter);
  };

  const onApply = () => {
    let updatedFilterParams;

    if (!filter.esType) {
      updatedFilterParams = getUpdatedVariablesFilterParams(
        'variableId',
        filter,
      );
    } else {
      const existsOperator = filter.operator === FilterItemOperatorTypes.EXISTS;
      const keyInQuery = filterParams.query?.[filter.esType]?.[filter.variable];

      if (keyInQuery) {
        delete filterParams.query?.[filter.esType]?.[filter.variable];
      }

      updatedFilterParams = getUpdatedFilterParams({
        key: filter.variable,
        value:
          existsOperator && filter.operator
            ? { [filter.operator]: filter.value === 'true' ? true : false }
            : filter.value,
        isExisting: false,
        type: filter.esType,
      });
    }

    setFilterParams(updatedFilterParams);
  };

  useEffect(() => {
    if (!hasFiltersByAttributes) {
      setFilter(blankFilterItem);
    }
  }, [hasFiltersByAttributes]);

  return (
    <>
      <AudienceFilterItemInput
        className={styles.otherAudienceFilters}
        filter={filter}
        setFilter={onUpdateOtherFilters}
        withIcons
      />
      <Button
        disabled={disabled || !filter.valid}
        css={{ container: styles.button }}
        onClick={onApply}
      >
        Apply
      </Button>
    </>
  );
};
